import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeInScale = keyframes`
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const Backdrop = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: ${props => props.$isOpen ? 'flex' : 'none'};
  align-items: flex-end;
  justify-content: center;
  animation: ${fadeIn} 0.3s ease-out;

  @media (min-width: 1024px) {
    align-items: center;
  }
`;

export const Content = styled.div<{ $fullScreen?: boolean }>`
  background: white;
  border-radius: ${props => props.$fullScreen ? '0' : '24px 24px 0 0'};
  max-width: ${props => props.$fullScreen ? '100%' : '500px'};
  width: 100%;
  max-height: ${props => props.$fullScreen ? '100%' : '90vh'};
  height: ${props => props.$fullScreen ? '100%' : 'auto'};
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: ${slideUp} 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  @media (min-width: 1024px) {
    border-radius: ${props => props.$fullScreen ? '0' : '24px'};
    max-width: ${props => props.$fullScreen ? '100%' : '640px'};
    max-height: ${props => props.$fullScreen ? '100%' : '88vh'};
    animation: ${fadeInScale} 0.3s ease-out;
  }
`;

export const Header = styled.div`
  padding: 24px 24px 16px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 900;
  color: var(--primary);
  text-transform: uppercase;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: #f3f4f6;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #e5e7eb;
    color: #6b7280;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const Body = styled.div<{ $noPadding?: boolean }>`
  flex: 1;
  overflow-y: auto;
  padding: ${props => props.$noPadding ? '0' : '24px'};

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }
`;

export const Footer = styled.div`
  padding: 16px 24px 24px;
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
`;
